module.exports = __webpack_public_path__ + "static/media/overpass-italic.f45ba39e.woff2";